import {Component, OnDestroy, OnInit} from '@angular/core';
import { Router } from '@angular/router';
import {NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import { JhiLanguageService } from 'ng-jhipster';

import { ProfileService } from '../profiles/profile.service'; // ToDo: Fix
import { JhiLanguageHelper, Principal, LoginModalService, LoginService, AccountService } from '../../shared';

import { VERSION, DEBUG_INFO_ENABLED, TRAINING } from '../../app.constants';
import {EventManagerService} from '../../shared/services/event-manager.service';
import { User } from '../../entities/user.model';
import {MaintenanceService} from '../../shared/services/maintenance.service';
import {Subscription} from 'rxjs/Subscription';
import {Maintenance} from '../../entities/maintenance.model';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit, OnDestroy {

  inProduction: boolean;
  isNavbarCollapsed: boolean;
  languages: any[];
  swaggerEnabled: boolean;
  modalRef: NgbModalRef;
  version: string;
  today: number = Date.now();
  user: User;
  trainingSystem = TRAINING;
  maintenances: Maintenance[] = [];

  private announcementSub: Subscription;

  constructor(
    private loginService: LoginService,
    private languageHelper: JhiLanguageHelper,
    private languageService: JhiLanguageService,
    private principal: Principal,
    private loginModalService: LoginModalService,
    private profileService: ProfileService,
    private router: Router,
    private eventManager: EventManagerService,
    private accountService: AccountService,
    private modalService: NgbModal,
    private maintenanceService: MaintenanceService
  ) {
    this.version = DEBUG_INFO_ENABLED ? 'v' + VERSION : '';
    this.isNavbarCollapsed = true;
    this.languageService.addLocation('home');

    this.accountService.get().subscribe((user: User) => {
      this.user = user;
    });
    this.announcementSub = this.maintenanceService.announcements
      .subscribe((maintenances: Maintenance[]) => this.maintenances = maintenances);
  }


  ngOnInit() {
    this.languageHelper.getAll().then((languages) => {
      this.languages = languages;
    });

    this.profileService.getProfileInfo().subscribe((profileInfo) => {
      this.inProduction = profileInfo.inProduction;
      this.swaggerEnabled = profileInfo.swaggerEnabled;
    });
  }

  ngOnDestroy() {
    if (this.announcementSub) {
      this.announcementSub.unsubscribe();
    }
  }

  changeLanguage(languageKey: string) {
    this.languageService.changeLanguage(languageKey);
  }

  collapseNavbar() {
    this.isNavbarCollapsed = true;
  }

  isAuthenticated() {
    return this.principal.isAuthenticated();
  }

  login() {
    this.modalRef = this.loginModalService.open();
  }

  logout() {
    this.loginService.logout();
    this.router.navigate(['']);
  }

  sidebarButtonClick() {
    this.eventManager.broadcast({
      name: 'toggleSidebar',
      content: 'Toggle Sidebar'
    });
  }

  openModal(modal: any) {
    this.modalRef = this.modalService.open(modal);
  }
}



// WEBPACK FOOTER //
// ./src/app/layouts/header/header.component.ts